import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { UserX, Trash2 } from "lucide-react";
import { toast } from "sonner";

export function AdminUsers() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const remove = async (e) => {
    e.preventDefault();
    const em = email.trim();
    if (!em) return;
    if (!window.confirm(`Permanently delete the account "${em}" and all its data? This cannot be undone.`)) return;
    setBusy(true);
    try {
      const { data } = await api.delete("/admin/users", { params: { email: em } });
      toast.success(`Removed ${data.deleted_email}`);
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't remove that account.");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="admin-users-btn"
          title="Remove a user account"
          className="hidden sm:inline-flex items-center gap-1.5 px-2 py-1 border border-border text-[10px] uppercase tracking-wider text-muted-foreground hover:border-destructive/60 hover:text-foreground transition-colors">
          <UserX size={12} /> Users
        </button>
      </DialogTrigger>
      <DialogContent className="bg-card border-2 border-foreground rounded-none max-w-md" data-testid="admin-users-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl uppercase flex items-center gap-2">
            <UserX className="text-destructive" size={24} /> Remove User
          </DialogTitle>
          <DialogDescription className="font-data text-xs">
            Deletes the account and all its predictions, ratings, memberships and referrals. Admins can't be deleted.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={remove} className="flex gap-2">
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="person@email.com" data-testid="admin-users-email"
            className="rounded-none font-data" />
          <Button type="submit" disabled={busy} data-testid="admin-users-remove"
            className="rounded-none bg-destructive text-destructive-foreground hover:brightness-110 uppercase text-xs font-bold">
            <Trash2 size={14} className="me-1" /> {busy ? "…" : "Remove"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
